
const ColorPalette = {
  transparent: "transparent",
  white: "#FFFFFF",
  black: "#000000",
  blueMain: "#5A80FB",
  blueLight1: "#7B98FC",
  blueLight2: "#9CB2FD",
  blueLight3: "#BDC9FE",
  blueLight4: "#E8EDFF",
  blueLight5: "#F5F7FF",
  blueDark: "#26347B",
  blueDark2: "#1A2559",
  blueAlpha: "rgba(90, 128, 251, 0.1)",
  blueAlpha2: "rgba(90, 128, 251, 0.05)",
  main: "#5A80FB",
  mainLight1: "#7B98FC",
  mainDark: "#26347B",
  secondary: "#ED3680",
  secondaryLight: "#FFDFEC",
  secondaryDark: "#D32B70",
  secondaryAlpha: "rgba(237, 54, 128, 0.1)",
  secondaryAlpha2: "rgba(237, 54, 128, 0.05)",
  chartBlue1: "#BDC9FE",
  chartBlue2: "#9CB2FD",
  chartBlue3: "#7B98FC",
  chartBlue4: "#5A80FB",
  chartBlue5: "#26347B",
  success: "#4CAF50",
  successLight: "#E8F5E9",
  warning: "#FF9800",
  warningLight: "#FFF3E0",
  error: "#F44336",
  errorLight: "#FFEBEE",
  info: "#2196F3",
  infoLight: "#E3F2FD",
  textDark: "#2D3748",
  textMedium: "#4A5568",
  textLight: "#718096",
  textBlue: "#2D7FF9",
  bgMain: "#F8F9FD",
  bgLight: "#FFFFFF",
  bgMedium: "#EDF2F7",
  bgSection1: "rgba(45, 127, 249, 0.03)",
  bgSection2: "rgba(45, 127, 249, 0.05)",
  bgSection3: "rgba(45, 127, 249, 0.07)",
  border: "#E2E8F0",
  borderDark: "#CBD5E0",
  shadow: "rgba(0, 0, 0, 0.05)"
};

export default ColorPalette;
